import Config from "Config/Config";
import { injectable, unmanaged } from "inversify";
import { EnvVariable } from "Models/EnvVariable";
import { EnvConfigUtils } from "Utils/EnvConfigUtils";
import { IHttpHeader } from "./IHttpHeader";

@injectable()
export class BaseApiService {
    private envConfigUtils: EnvConfigUtils;
    private uri: string = "";
    private baseUrl: string = "";

    protected get headers(): IHttpHeader {
        return {
            "Accept": "application/json",
            Pragma: "no-cache",
            ...this.getAuthorizationHeaders()
        };
    }

    private getAuthorizationHeaders(): object {
        const strToken = sessionStorage.getItem(Config.STORAGE_TOKEN);
        if(strToken) {
            const tokenObj = JSON.parse(strToken);
            if(tokenObj) {
                return {
                    Authorization: tokenObj.token,
                    companyId: tokenObj.companyId
                };
            }
        }
        return {};
    }

    protected get endpoint(): string {
        return `${this.baseUrl}${this.uri}`;
    }

    public constructor(@unmanaged() envConfigUtils: EnvConfigUtils, uri: string) {
        this.envConfigUtils = envConfigUtils;
        this.uri = uri;
    }

    protected init = (): void => {
        if (this.baseUrl === "") {
            const envVariable: EnvVariable = this.envConfigUtils.getEnvVariables();
            this.baseUrl = envVariable.apiUrl;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Service/BaseApiService.tsx